'use client';

import { I18nextProvider } from 'react-i18next';
import globalI18n from '@benzinga/translate';
import initTranslations from '../i18n/translations';
import { createInstance } from 'i18next';

export default function TranslationsProvider({ children, locale, namespaces, resources }) {
  const i18n = createInstance();

  initTranslations(locale, namespaces, i18n, resources);

  if (resources && locale) {
    for (const ns of namespaces) {
      if (resources[locale]?.[ns]) {
        globalI18n.addResourceBundle(locale, ns, resources[locale][ns], true, true);
      }
    }
    if (globalI18n.language !== locale) {
      globalI18n.changeLanguage(locale);
    }
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
